import Helper from '../Classes/Helper';
import Product from './Product';
import {get, writable} from 'svelte/store';

const data = {};
const preference = writable(data);

async function getIndex(step, group, property) {
	const path = `${step || ''}.${group || ''}.${property || ''}`;
	const index = await Helper.hash(path);
	return `_${index}`;
}

preference.getData = () => data;
preference.setData = data => {
	preference.set(data);
};

preference.setContextValue = async (step, group, property, value) => {
	const index = await getIndex(step, group, property);
	data[index] = value;
	preference.set(data);
};

preference.getContextValue = async (step, group, property) => {
	const index = await getIndex(step, group, property);
	return Helper.undefined(data[index]) ? '' : data[index];
};

preference.setValue = async value => {
	const product = get(Product);
	const step = product.step.name;
	const group = product.group.name;
	const property = product.property.name;
	await preference.setContextValue(step, group, property, value);
};

preference.getValue = async () => {
	const product = get(Product);
	const step = product.step.name;
	const group = product.group.name;
	const property = product.property.name;
	const value = await preference.getContextValue(step, group, property);
	return value;
};

export default preference;